export const FETCH_FUND_ANALYSIS_V2 = 'analysis/FETCH_FUND_ANALYSIS_V2';
export const FETCH_FUND_ANALYSIS_V2_FROM_ORG_FUNDS =
  'analysis/FETCH_FUND_ANALYSIS_V2_BY_ORG_FUNDS';
export const FETCH_SCHEME_ANALYSIS = 'analysis/FETCH_SCHEME_ANALYSIS';
export const FETCH_SUBMISSION_SUMMARY = 'analysis/FETCH_SUBMISSION_SUMMARY';
export const FETCH_SUBFUND_ANALYSIS = 'analysis/FETCH_SUBFUND_ANALYSIS';
export const FETCH_CONSULTANT_ANALYSIS = 'analysis/FETCH_CONSULTANT_ANALYSIS';
export const FETCH_PROVIDER_ANALYSIS = 'analysis/FETCH_PROVIDER_ANALYSIS';
export const FETCH_FIDUCIARY_ANALYSIS = 'analysis/FETCH_FIDUCIARY_ANALYSIS';
